/**
 * Directive: pageHeader
 */
angular.module('acme.common.directive.pageHeader', [])
.directive('pageHeader', [function() {

    return {
      restrict: 'A',
      replace: true,
      transclude: true,
      templateUrl: 'common/directives/pageHeader/pageHeader.tpl.html',
      scope: {
        title: '@',
        description: '@'
      },
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.pageHeader = {};

      }]

    };

}]);